import { call, takeLatest } from "redux-saga/effects";
import {
  alternativeItemsListApi,
  currentPrintPreferenceApi,
  deleteAlternativeTransApi,
  documentNumberingList,
  documentNumberingSeriesAddApi,
  documentNumberingSeriesList,
  documentNumberingSeriesUpdateApi,
  documentNumberingUpdateApi,
  customNumberingList,
  customNumberingSeriesAddApi,
  customNumberingSeriesList,
  customNumberingSeriesUpdateApi,
  customNumberingUpdateApi,
  itemCategoryAddApi,
  itemCategoryDeleteApi,
  itemCategoryImportApi,
  itemCategoryListApi,
  itemCategoryUpdateApi,
  itemGroupAddApi,
  itemGroupDeleteApi,
  itemGroupImportApi,
  itemGroupListApi,
  itemGroupUpdateApi,
  itemTypeAddApi,
  itemTypeDeleteApi,
  itemTypeImportApi,
  itemTypeListApi,
  itemTypeUpdateApi,
  manufacturerAddApi,
  manufacturerDeleteApi,
  manufacturerImportApi,
  manufacturerListApi,
  manufacturerUpdateApi,
  mapAlternativerItemApi,
  alternativerItemImportApi,
  paytmAddApi,
  paytmUpdateApi,
  paytmViewApi,
  phonepeAddApi,
  phonepeUpdateApi,
  phonepeViewApi,
  pineLabsAddApi,
  pineLabsUpdateApi,
  pineLabsViewApi,
  printPreferenceListApi,
  printPreferenceUpdateApi,
  razorpayAddApi,
  razorpayUpdateApi,
  razorpayViewApi,
  shippingTypeAddApi,
  shippingTypeDeleteApi,
  shippingTypeImportApi,
  shippingTypeListApi,
  shippingTypeUpdateApi,
  smsAddApi,
  smsUpdateApi,
  smsViewApi,
  smtpAddApi,
  smtpUpdateApi,
  smtpViewApi,
  storeDetailsGetApi,
  storeDetailsUpdateApi,
  stripeAddApi,
  stripeUpdateApi,
  stripeViewApi,
  taxCombinationAddApi,
  taxCombinationDeleteApi,
  taxCombinationImportApi,
  taxCombinationItemDeleteApi,
  taxCombinationListApi,
  taxCombinationUpdateApi,
  taxTypeAddApi,
  taxTypeDeleteApi,
  taxTypeDropDownApi,
  taxTypeImportApi,
  taxTypeListApi,
  taxTypeUpdateApi,
  tcsTaxCreateApi,
  tcsTaxDeleteApi,
  tcsTaxListApi,
  tdsTaxCreateApi,
  tdsTaxDeleteApi,
  tdsTaxListApi,
  templateCreateApi,
  templateDeleteApi,
  templateEditApi,
  templateTableApi,
  templateViewApi,
  uomCreateApi,
  uomGroupDataAddApi,
  uomGroupDataListApi,
  uomGroupDataUpdateApi,
  uomGroupDeleteApi,
  uomGroupImportAddApi,
  uomGroupItemDeleteApi,
  uomGroupItemImportApi,
  uomGroupUomListApi,
  uomGroupCalculationApi,
  uomImportApi,
  uomListApi,
  uomUpdateApi,
  whatsappAddApi,
  whatsappUpdateApi,
  whatsappViewApi,
  tcsTaxImportApi,
  tdsTaxImportApi,
  BillingTypesApi,
  departmentSearchApi,
  roleCreateApi,
  roleSearchApi,
  roleEditeApi,
  roleDeleteApi,
  roleDocumentUploadApi,
  departmentCreateApi,
  departmentEditeApi,
  departmentDeleteApi,
  departmentDocumentUploadApi,
  attachedRolesDepartmentCreateApi,
  attachedRolesDepartmentDeleteApi,
  moduleSettingsGetAllApi,
  moduleSettingsUpdateApi,
  partyListApi,
  drugSearchApi,
  drugCreateApi,
  drugEditeApi,
  drugDocumentUploadApi,
  drugDeleteApi,
  leadSearchApi,
  leadCreateApi,
  leadEditApi,
  leadDeleteApi,
  leadDocumentUploadApi,
  paymentSearchApi,
  paymentCreateApi,
  paymentEditApi,
  paymentDeleteApi,
  paymentDocumentUploadApi,
  // 📦 Packing
  packingSearchApi,
  packingCreateApi,
  packingEditApi,
  packingDeleteApi,
  packingDocumentUploadApi,

  // 📦 Packing Type
  packingTypeSearchApi,
  packingTypeCreateApi,
  packingTypeEditApi,
  packingTypeDeleteApi,
  packingTypeDocumentUploadApi,

  // 📦 Carton
  cartonSearchApi,
  cartonCreateApi,
  cartonEditApi,
  cartonDeleteApi,
  cartonDocumentUploadApi,
  partySearchApi,
  partyCreateApi,
  partyEditApi,
  partyDeleteApi,
  partyDocumentUploadApi,
  partyCategorySearchApi,
  partyCategoryCreateApi,
  partyCategoryEditApi,
  partyCategoryDeleteApi,
  partyCategoryDocumentUploadApi,
  partyGroupSearchApi,
  partyGroupCreateApi,
  partyGroupEditApi,
  partyGroupDeleteApi,
  partyGroupDocumentUploadApi,
  countrySearchApi,
  countryCreateApi,
  countryEditApi,
  countryDeleteApi,
  countryDocumentUploadApi,
  regionSearchApi,
  regionCreateApi,
  regionEditApi,
  regionDeleteApi,
  regionDocumentUploadApi,
  stateSearchApi,
  stateCreateApi,
  stateEditApi,
  stateDeleteApi,
  stateDocumentUploadApi,
  districtSearchApi,
  districtCreateApi,
  districtEditApi,
  districtDeleteApi,
  districtDocumentUploadApi,
  citySearchApi,
  cityCreateApi,
  cityEditApi,
  cityDeleteApi,
  cityDocumentUploadApi,
  areaSearchApi,
  areaCreateApi,
  areaEditApi,
  areaDeleteApi,
  areaDocumentUploadApi,
  specializationSearchApi,
  specializationCreateApi,
  specializationEditApi,
  specializationDeleteApi,
  specializationDocumentUploadApi,
  subSpecialSearchApi,
  subSpecialCreateApi,
  subSpecialEditApi,
  subSpecialDeleteApi,
  subSpecialDocumentUploadApi,
  insuranceSearchApi,
  insuranceCreateApi,
  insuranceEditApi,
  insuranceDeleteApi,
  insuranceDocumentUploadApi,
  uomDropDownApi,
  compositionSearchApi,
  compositionCreateApi,
  compositionEditApi,
  compositionDeleteApi,
  compositionDocumentUploadApi,
  addCustomInvoiceApi,
  uomDropDownApiNew,
  genericSearchApi,
  genericCreateApi,
  genericDeleteApi,
  genericDocumentUploadApi,
  genericEditApi,
} from "../apis/settings-api";
import {
  ADD_ITEM_CATEGORY,
  ADD_ITEM_GROUP,
  ADD_ITEM_TYPE,
  ADD_MANUFACTURER,
  ADD_SHIPPING_TYPE,
  ADD_TAX_COMBINATION,
  ADD_TAX_TYPE,
  ADD_UOM,
  ADD_UOM_GROUP,
  ALTERNATIVE_ITEMS_IMPORT,
  ALTERNATIVE_ITEMS_LIST,
  CURRENT_PRINTPREFERENCE,
  DELETE_ALTERNATIVE_TRANSACTION,
  DELETE_ITEM_CATEGORY,
  DELETE_ITEM_GROUP,
  DELETE_ITEM_TYPE,
  DELETE_MANUFACTURER,
  DELETE_SHIPPING_TYPE,
  DELETE_TAX_COMBINATION,
  DELETE_TAX_COMBINATION_ITEM,
  DELETE_TAX_TYPE,
  DELETE_UOM_GROUP,
  DELETE_UOM_GROUP_ITEM,
  DOCUMENT_NUMBERING_LIST,
  DOCUMENT_NUMBERING_SERIES_ADD,
  DOCUMENT_NUMBERING_SERIES_LIST,
  DOCUMENT_NUMBERING_SERIES_UPDATE,
  DOCUMENT_NUMBERING_UPDATE,
  ITEM_CATEGORY_IMPORT,
  ITEM_CATEGORY_LIST,
  ITEM_GROUP_IMPORT,
  ITEM_GROUP_TABLE_LIST,
  ITEM_TYPE_IMPORT,
  ITEM_TYPE_LIST,
  LIST_UOM,
  MANUFACTURERS_IMPORT,
  MANUFACTURERS_TABLE_LIST,
  MAP_ALTERNATIVE_ITEM,
  PAYTM_ADD,
  PAYTM_UPDATE,
  PAYTM_VIEW,
  PHONEPE_ADD,
  PHONEPE_UPDATE,
  PHONEPE_VIEW,
  PINE_LABS_ADD,
  PINE_LABS_UPDATE,
  PINE_LABS_VIEW,
  PRINTPREFERENCE_LIST,
  PRINTPREFERENCE_UPDATE,
  RAZORPAY_ADD,
  RAZORPAY_UPDATE,
  RAZORPAY_VIEW,
  SHIPPING_TYPE_IMPORT,
  SHIPPING_TYPE_TABLE__LIST,
  SMS_ADD,
  SMS_UPDATE,
  SMS_VIEW,
  SMTP_ADD,
  SMTP_UPDATE,
  SMTP_VIEW,
  STORE_GET,
  STORE_UPDATE,
  STRIPE_ADD,
  STRIPE_UPDATE,
  STRIPE_VIEW,
  TAX_COMBINATION_IMPORT,
  TAX_COMBINATION_LIST,
  TAX_TYPE_DROPDOWN,
  TAX_TYPE_IMPORT,
  TAX_TYPE_LIST,
  TCS_TAX_ADD,
  TCS_TAX_DELETE,
  TCS_TAX_IMPORT,
  TCS_TAX_LIST,
  TDS_TAX_ADD,
  TDS_TAX_DELETE,
  TDS_TAX_IMPORT,
  TDS_TAX_LIST,
  TEMPLATE_CREATE,
  TEMPLATE_DELETE,
  TEMPLATE_EDIT,
  TEMPLATE_TABLE,
  TEMPLATE_VIEW,
  UOM_DROPDOWN,
  UOM_GROUP_CALCULATION,
  UOM_GROUP_IMPORT,
  UOM_GROUP_ITEM_IMPORT,
  UOM_GROUP_TABLE_LIST,
  UOM_IMPORT,
  UPDATE_ITEM_CATEGORY,
  UPDATE_ITEM_GROUP,
  UPDATE_ITEM_TYPE,
  UPDATE_MANUFACTURER,
  UPDATE_SHIPPING_TYPE,
  UPDATE_TAX_COMBINATION,
  UPDATE_TAX_TYPE,
  UPDATE_UOM,
  UPDATE_UOM_GROUP,
  WHATSAPP_ADD,
  WHATSAPP_UPDATE,
  WHATSAPP_VIEW,
  BILLING_TYPES,
  CUSTOM_NUMBERING_SERIES_UPDATE,
  CUSTOM_NUMBERING_SERIES_ADD,
  CUSTOM_NUMBERING_SERIES_LIST,
  CUSTOM_NUMBERING_UPDATE,
  CUSTOM_NUMBERING_LIST,
  ATTACHED_ROLES_DEPARTMENT_DELETE,
  ATTACHED_ROLES_DEPARTMENT_CREATE,
  DEPARTMENT_UPLOAD,
  DEPARTMENT_DELETE,
  DEPARTMENT_EDIT,
  DEPARTMENT_CREATE,
  ROLE_UPLOAD,
  ROLE_DELETE,
  ROLE_EDIT,
  ROLE_CREATE,
  ROLE_SEARCH,
  DEPARTMENT_SEARCH,
  MODULE_SETTINGS_GET_ALL,
  MODULE_SETTINGS_UPDATE,
  PARTY_LIST,
  DRUG_SEARCH,
  DRUG_CREATE,
  DRUG_EDIT,
  DRUG_DELETE,
  DRUG_UPLOAD,
  GENERIC_SEARCH,
  GENERIC_CREATE,
  GENERIC_DELETE,
  GENERIC_EDIT,
  GENERIC_UPLOAD,
  COMPOSITION_SEARCH,
  COMPOSITION_CREATE,
  COMPOSITION_DELETE,
  COMPOSITION_EDIT,
  COMPOSITION_UPLOAD,
  LEAD_SEARCH,
  LEAD_CREATE,
  LEAD_DELETE,
  LEAD_EDIT,
  LEAD_UPLOAD,
  PAYMENT_SEARCH,
  PAYMENT_CREATE,
  PAYMENT_DELETE,
  PAYMENT_EDIT,
  PAYMENT_UPLOAD,
  PACKING_SEARCH,
  PACKING_CREATE,
  PACKING_DELETE,
  PACKING_EDIT,
  PACKING_UPLOAD,
  PACKING_TYPE_SEARCH,
  PACKING_TYPE_CREATE,
  PACKING_TYPE_DELETE,
  PACKING_TYPE_EDIT,
  PACKING_TYPE_UPLOAD,
  CARTON_SEARCH,
  CARTON_CREATE,
  CARTON_DELETE,
  CARTON_EDIT,
  CARTON_UPLOAD,
  PARTY_SEARCH,
  PARTY_CREATE,
  PARTY_DELETE,
  PARTY_EDIT,
  PARTY_UPLOAD,
  PARTY_CATEGORY_SEARCH,
  PARTY_CATEGORY_CREATE,
  PARTY_CATEGORY_DELETE,
  PARTY_CATEGORY_EDIT,
  PARTY_CATEGORY_UPLOAD,
  PARTY_GROUP_SEARCH,
  PARTY_GROUP_CREATE,
  PARTY_GROUP_DELETE,
  PARTY_GROUP_EDIT,
  PARTY_GROUP_UPLOAD,
  COUNTRY_SEARCH,
  COUNTRY_CREATE,
  COUNTRY_DELETE,
  COUNTRY_EDIT,
  COUNTRY_UPLOAD,
  REGION_SEARCH,
  REGION_CREATE,
  REGION_DELETE,
  REGION_EDIT,
  REGION_UPLOAD,
  STATE_SEARCH,
  STATE_CREATE,
  STATE_DELETE,
  STATE_EDIT,
  STATE_UPLOAD,
  DISTRICT_SEARCH,
  DISTRICT_CREATE,
  DISTRICT_DELETE,
  DISTRICT_EDIT,
  DISTRICT_UPLOAD,
  CITY_SEARCH,
  CITY_CREATE,
  CITY_DELETE,
  CITY_EDIT,
  CITY_UPLOAD,
  AREA_SEARCH,
  AREA_CREATE,
  AREA_DELETE,
  AREA_EDIT,
  AREA_UPLOAD,
  SPECIALIZATION_SEARCH,
  SPECIALIZATION_CREATE,
  SPECIALIZATION_DELETE,
  SPECIALIZATION_EDIT,
  SPECIALIZATION_UPLOAD,
  SUB_SPECIAL_SEARCH,
  SUB_SPECIAL_CREATE,
  SUB_SPECIAL_EDIT,
  SUB_SPECIAL_DELETE,
  SUB_SPECIAL_UPLOAD,
  INSURANCE_SEARCH,
  INSURANCE_CREATE,
  INSURANCE_EDIT,
  INSURANCE_DELETE,
  INSURANCE_UPLOAD,
  ADD_CUSTOM_INVOICE,
  UOM_DROPDOWN_NEW,
} from "../types";

/**UOM */
export function* uomCreateWorker(action) {
  try {
    const res = yield call(uomCreateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* uomUpdateWorker(action) {
  try {
    const res = yield call(uomUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* uomListWorker(action) {
  try {
    const res = yield call(uomListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* uomImportWorker(action) {
  try {
    const res = yield call(uomImportApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

/**UOM GROUPS */
export function* uomGroupDataListWorker(action) {
  try {
    const res = yield call(uomGroupDataListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* uomGroupDataAddWorker(action) {
  try {
    const res = yield call(uomGroupDataAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* uomGroupDataUpdateWorker(action) {
  try {
    const res = yield call(uomGroupDataUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* uomGroupDeleteWorker(action) {
  try {
    const res = yield call(uomGroupDeleteApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* uomGroupImportWorker(action) {
  try {
    const res = yield call(uomGroupImportAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* uomGroupCalculationWorker(action) {
  try {
    const res = yield call(uomGroupCalculationApi, action.data);
    console.log("Saga - Full response:", res);
    console.log("Saga - Response data:", res.data);

    // Check for success based on the response structure
    if (res.data?.status === true || res.data?.code === 200 || (res.data?.data && Array.isArray(res.data.data))) {
      yield action.onSuccess(res.data);
    } else {
      console.log("Saga - Error condition met, response:", res.data);
      yield action.onError(res?.data);
    }
  } catch (error) {
    console.log("Saga - Catch error:", error);
    yield action.onError(error?.response);
  }
}

export function* uomGroupItemDeleteWorker(action) {
  try {
    const res = yield call(uomGroupItemDeleteApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* uomGroupItemImportWorker(action) {
  try {
    const res = yield call(uomGroupItemImportApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* uomGroupuomListWorker(action) {
  try {
    const res = yield call(uomDropDownApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* uomGroupuomListNewWorker(action) {
  try {
    const res = yield call(uomDropDownApiNew, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

/**Item Setup */
export function* itemTypeAddWorker(action) {
  try {
    const res = yield call(itemTypeAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* itemTypeUpdateWorker(action) {
  try {
    const res = yield call(itemTypeUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* itemTypeDeleteWorker(action) {
  try {
    const res = yield call(itemTypeDeleteApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* itemTypeListWorker(action) {
  try {
    const res = yield call(itemTypeListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* itemTypeImportWorker(action) {
  try {
    const res = yield call(itemTypeImportApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* itemCategoryAddWorker(action) {
  try {
    const res = yield call(itemCategoryAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* itemCategoryUpdateWorker(action) {
  try {
    const res = yield call(itemCategoryUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* itemCategoryDeleteWorker(action) {
  try {
    const res = yield call(itemCategoryDeleteApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* itemCategoryListWorker(action) {
  try {
    const res = yield call(itemCategoryListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* itemCategoryImportWorker(action) {
  try {
    const res = yield call(itemCategoryImportApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* itemGroupAddWorker(action) {
  try {
    const res = yield call(itemGroupAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* itemGroupUpdateWorker(action) {
  try {
    const res = yield call(itemGroupUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* itemGroupDeleteWorker(action) {
  try {
    const res = yield call(itemGroupDeleteApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* itemGroupListWorker(action) {
  try {
    const res = yield call(itemGroupListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* itemGroupImportWorker(action) {
  try {
    const res = yield call(itemGroupImportApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

/**Manufacturer Setup */
export function* manufacturerAddWorker(action) {
  try {
    const res = yield call(manufacturerAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* manufacturerUpdateWorker(action) {
  try {
    const res = yield call(manufacturerUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* manufacturerDeleteWorker(action) {
  try {
    const res = yield call(manufacturerDeleteApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* manufacturerTableListWorker(action) {
  try {
    const res = yield call(manufacturerListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* manufacturerImportWorker(action) {
  try {
    const res = yield call(manufacturerImportApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

/**Tax Setup */
export function* taxTypeAddWorker(action) {
  try {
    const res = yield call(taxTypeAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* taxTypeUpdateWorker(action) {
  try {
    const res = yield call(taxTypeUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* taxTypeDeleteWorker(action) {
  try {
    const res = yield call(taxTypeDeleteApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* taxTypeListWorker(action) {
  try {
    const res = yield call(taxTypeListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* taxTypeImportWorker(action) {
  try {
    const res = yield call(taxTypeImportApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* taxCombinationAddWorker(action) {
  try {
    const res = yield call(taxCombinationAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* taxCombinationUpdateWorker(action) {
  try {
    const res = yield call(taxCombinationUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* taxCombinationListWorker(action) {
  try {
    const res = yield call(taxCombinationListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* taxCombinationDeleteWorker(action) {
  try {
    const res = yield call(taxCombinationDeleteApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* taxCombinationItemDeleteWorker(action) {
  try {
    const res = yield call(taxCombinationItemDeleteApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* taxTypeDropDownWorker(action) {
  try {
    const res = yield call(taxTypeDropDownApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* taxCombinationImportWorker(action) {
  try {
    const res = yield call(taxCombinationImportApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

/**Shipping Type */

export function* shippingTypeAddWorker(action) {
  try {
    const res = yield call(shippingTypeAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* shippingTypeUpdateWorker(action) {
  try {
    const res = yield call(shippingTypeUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* shippingTypeListWorker(action) {
  try {
    const res = yield call(shippingTypeListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* shippingTypeDeleteWorker(action) {
  try {
    const res = yield call(shippingTypeDeleteApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* shippingTypeImportWorker(action) {
  try {
    const res = yield call(shippingTypeImportApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

/**Document Numbering */
export function* documentNumberListWorker(action) {
  try {
    const res = yield call(documentNumberingList, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* documentNumberUpdateWorker(action) {
  try {
    const res = yield call(documentNumberingUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* documentNumberSeriesListWorker(action) {
  try {
    const res = yield call(documentNumberingSeriesList, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* documentNumberSeriesAddWorker(action) {
  try {
    const res = yield call(documentNumberingSeriesAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* documentNumberSeriesUpdateWorker(action) {
  try {
    const res = yield call(documentNumberingSeriesUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
/**Document Numbering */
export function* customNumberListWorker(action) {
  try {
    const res = yield call(customNumberingList, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customNumberUpdateWorker(action) {
  try {
    const res = yield call(customNumberingUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customNumberSeriesListWorker(action) {
  try {
    const res = yield call(customNumberingSeriesList, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customNumberSeriesAddWorker(action) {
  try {
    const res = yield call(customNumberingSeriesAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customNumberSeriesUpdateWorker(action) {
  try {
    const res = yield call(customNumberingSeriesUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

/**Communication  */
//SMTP
export function* smtpViewWorker(action) {
  try {
    const res = yield call(smtpViewApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* smtpAddWorker(action) {
  try {
    const res = yield call(smtpAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* smtpUpdateWorker(action) {
  try {
    const res = yield call(smtpUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

//Whatsapp
export function* whatsappViewWorker(action) {
  try {
    const res = yield call(whatsappViewApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* whatsappAddWorker(action) {
  try {
    const res = yield call(whatsappAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* whatsappUpdateWorker(action) {
  try {
    const res = yield call(whatsappUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

//SMS
export function* smsViewWorker(action) {
  try {
    const res = yield call(smsViewApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* smsAddWorker(action) {
  try {
    const res = yield call(smsAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* smsUpdateWorker(action) {
  try {
    const res = yield call(smsUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

/**Payment Configuration */
//Razorpay
export function* razorpayViewWorker(action) {
  try {
    const res = yield call(razorpayViewApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* razorpayAddWorker(action) {
  try {
    const res = yield call(razorpayAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* razorpayUpdateWorker(action) {
  try {
    const res = yield call(razorpayUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

//Stripe
export function* stripeViewWorker(action) {
  try {
    const res = yield call(stripeViewApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* stripeAddWorker(action) {
  try {
    const res = yield call(stripeAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* stripeUpdateWorker(action) {
  try {
    const res = yield call(stripeUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

//Phonepe
export function* phonepeViewWorker(action) {
  try {
    const res = yield call(phonepeViewApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* phonepeAddWorker(action) {
  try {
    const res = yield call(phonepeAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* phonepeUpdateWorker(action) {
  try {
    const res = yield call(phonepeUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

//Paytm
export function* paytmViewWorker(action) {
  try {
    const res = yield call(paytmViewApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* paytmAddWorker(action) {
  try {
    const res = yield call(paytmAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* paytmUpdateWorker(action) {
  try {
    const res = yield call(paytmUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

//Pine Labs
export function* pineLabsViewWorker(action) {
  try {
    const res = yield call(pineLabsViewApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* pineLabsAddWorker(action) {
  try {
    const res = yield call(pineLabsAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* pineLabsUpdateWorker(action) {
  try {
    const res = yield call(pineLabsUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* printPreferenceListWorker(action) {
  try {
    const res = yield call(printPreferenceListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* BillTypesWorker(action) {
  try {
    const res = yield call(BillingTypesApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* printPreferenceUpdateWorker(action) {
  try {
    const res = yield call(printPreferenceUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* currentPrintPreferenceWorker(action) {
  try {
    const res = yield call(currentPrintPreferenceApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* storeDetailsUpdateWorker(action) {
  try {
    const res = yield call(storeDetailsUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* storeDetailsGetWorker(action) {
  try {
    const res = yield call(storeDetailsGetApi, action.data);
    if (res.data?.code === 200) {
      localStorage.setItem("company", res?.data?.data?.company);
      localStorage.setItem(
        "company_landmark",
        res?.data?.data?.company_landmark
      );
      localStorage.setItem("store_icon", res?.data?.data?.store_icon);
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

// Alternative item setup
export function* mapAlternativerItemWorker(action) {
  try {
    const res = yield call(mapAlternativerItemApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* alternativeItemsListWorker(action) {
  try {
    const res = yield call(alternativeItemsListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* deleteAlternativeTransWorker(action) {
  try {
    const res = yield call(deleteAlternativeTransApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* alternativerItemImportWorker(action) {
  try {
    const res = yield call(alternativerItemImportApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* addCustomInvoiceWorker(action) {
  try {
    const res = yield call(addCustomInvoiceApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* tcsTaxListWorker(action) {
  try {
    const res = yield call(tcsTaxListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* tcsTaxCreateWorker(action) {
  try {
    const res = yield call(tcsTaxCreateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* tcsTaxDeleteWorker(action) {
  try {
    const res = yield call(tcsTaxDeleteApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* tcsTaxImportWorker(action) {
  try {
    const res = yield call(tcsTaxImportApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* tdsTaxListWorker(action) {
  try {
    const res = yield call(tdsTaxListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* tdsTaxCreateWorker(action) {
  try {
    const res = yield call(tdsTaxCreateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* tdsTaxDeleteWorker(action) {
  try {
    const res = yield call(tdsTaxDeleteApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* tdsTaxImportWorker(action) {
  try {
    const res = yield call(tdsTaxImportApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* partyListWorker(action) {
  try {
    const res = yield call(partyListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* templateCreateWorker(action) {
  try {
    const res = yield call(templateCreateApi, action.data);

    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* templateTableWorker(action) {
  try {
    const res = yield call(templateTableApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* templateViewWorker(action) {
  try {
    const res = yield call(templateViewApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* templateDeleteWorker(action) {
  try {
    const res = yield call(templateDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* templateEditWorker(action) {
  try {
    const res = yield call(templateEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

/**Watcher functions */

/**UOM */
export function* uomCreateWatcher() {
  yield takeLatest(ADD_UOM, uomCreateWorker);
}

export function* uomUpdateWatcher() {
  yield takeLatest(UPDATE_UOM, uomUpdateWorker);
}

export function* uomListWatcher() {
  yield takeLatest(LIST_UOM, uomListWorker);
}
export function* uomImportWatcher() {
  yield takeLatest(UOM_IMPORT, uomImportWorker);
}

/**UOM GROUPS */
export function* uomGroupDataListWatcher() {
  yield takeLatest(UOM_GROUP_TABLE_LIST, uomGroupDataListWorker);
}

export function* uomGroupDataAddWatcher() {
  yield takeLatest(ADD_UOM_GROUP, uomGroupDataAddWorker);
}

export function* uomGroupDataUpdateWatcher() {
  yield takeLatest(UPDATE_UOM_GROUP, uomGroupDataUpdateWorker);
}

export function* uomGroupDeleteWatcher() {
  yield takeLatest(DELETE_UOM_GROUP, uomGroupDeleteWorker);
}

export function* uomGroupItemDeleteWatcher() {
  yield takeLatest(DELETE_UOM_GROUP_ITEM, uomGroupItemDeleteWorker);
}

export function* uomGroupUomListWatcher() {
  yield takeLatest(UOM_DROPDOWN, uomGroupuomListWorker);
}

export function* uomGroupUomListNewWatcher() {
  yield takeLatest(UOM_DROPDOWN_NEW, uomGroupuomListNewWorker);
}

export function* uomGroupImportWatcher() {
  yield takeLatest(UOM_GROUP_IMPORT, uomGroupImportWorker);
}
export function* uomGroupItemImportWatcher() {
  yield takeLatest(UOM_GROUP_ITEM_IMPORT, uomGroupItemImportWorker);
}

export function* uomGroupCalculationWatcher() {
  yield takeLatest(UOM_GROUP_CALCULATION, uomGroupCalculationWorker);
}

/**Item Setup */
export function* itemTypeAddWatcher() {
  yield takeLatest(ADD_ITEM_TYPE, itemTypeAddWorker);
}

export function* itemTypeUpdateWatcher() {
  yield takeLatest(UPDATE_ITEM_TYPE, itemTypeUpdateWorker);
}

export function* itemTypeDeleteWatcher() {
  yield takeLatest(DELETE_ITEM_TYPE, itemTypeDeleteWorker);
}

export function* itemTypeListWatcher() {
  yield takeLatest(ITEM_TYPE_LIST, itemTypeListWorker);
}

export function* itemCategoryAddWatcher() {
  yield takeLatest(ADD_ITEM_CATEGORY, itemCategoryAddWorker);
}

export function* itemCategoryUpdateWatcher() {
  yield takeLatest(UPDATE_ITEM_CATEGORY, itemCategoryUpdateWorker);
}

export function* itemCategoryListWatcher() {
  yield takeLatest(ITEM_CATEGORY_LIST, itemCategoryListWorker);
}

export function* itemCategoryDeleteWatcher() {
  yield takeLatest(DELETE_ITEM_CATEGORY, itemCategoryDeleteWorker);
}

export function* itemGroupAddWatcher() {
  yield takeLatest(ADD_ITEM_GROUP, itemGroupAddWorker);
}

export function* itemGroupUpdateWatcher() {
  yield takeLatest(UPDATE_ITEM_GROUP, itemGroupUpdateWorker);
}

export function* itemGroupDeleteWatcher() {
  yield takeLatest(DELETE_ITEM_GROUP, itemGroupDeleteWorker);
}

export function* itemGroupListWatcher() {
  yield takeLatest(ITEM_GROUP_TABLE_LIST, itemGroupListWorker);
}
export function* itemTypeImportWatcher() {
  yield takeLatest(ITEM_TYPE_IMPORT, itemTypeImportWorker);
}
export function* itemCategoryImportWatcher() {
  yield takeLatest(ITEM_CATEGORY_IMPORT, itemCategoryImportWorker);
}
export function* itemGroupImportWatcher() {
  yield takeLatest(ITEM_GROUP_IMPORT, itemGroupImportWorker);
}

/**Manufacturer setup */
export function* manufacturerAddWatcher() {
  yield takeLatest(ADD_MANUFACTURER, manufacturerAddWorker);
}

export function* manufacturerUpdateWatcher() {
  yield takeLatest(UPDATE_MANUFACTURER, manufacturerUpdateWorker);
}

export function* manufacturerDeleteWatcher() {
  yield takeLatest(DELETE_MANUFACTURER, manufacturerDeleteWorker);
}

export function* manufacturerTableListWatcher() {
  yield takeLatest(MANUFACTURERS_TABLE_LIST, manufacturerTableListWorker);
}
export function* manufacturerImportWatcher() {
  yield takeLatest(MANUFACTURERS_IMPORT, manufacturerImportWorker);
}

/**Tax setup */
export function* taxTypeAddWatcher() {
  yield takeLatest(ADD_TAX_TYPE, taxTypeAddWorker);
}

export function* taxTypeUpdateWatcher() {
  yield takeLatest(UPDATE_TAX_TYPE, taxTypeUpdateWorker);
}

export function* taxTypeDeleteWatcher() {
  yield takeLatest(DELETE_TAX_TYPE, taxTypeDeleteWorker);
}
export function* taxTypeImportWatcher() {
  yield takeLatest(TAX_TYPE_IMPORT, taxTypeImportWorker);
}

export function* taxTypeTableListWatcher() {
  yield takeLatest(TAX_TYPE_LIST, taxTypeListWorker);
}

export function* taxCombinationAddWatcher() {
  yield takeLatest(ADD_TAX_COMBINATION, taxCombinationAddWorker);
}

export function* taxCombinationUpdateWatcher() {
  yield takeLatest(UPDATE_TAX_COMBINATION, taxCombinationUpdateWorker);
}

export function* taxCombinationDeleteWatcher() {
  yield takeLatest(DELETE_TAX_COMBINATION, taxCombinationDeleteWorker);
}

export function* taxCombinationItemDeleteWatcher() {
  yield takeLatest(DELETE_TAX_COMBINATION_ITEM, taxCombinationItemDeleteWorker);
}

export function* taxCombinationTableListWatcher() {
  yield takeLatest(TAX_COMBINATION_LIST, taxCombinationListWorker);
}

export function* taxTypeDropDownWatcher() {
  yield takeLatest(TAX_TYPE_DROPDOWN, taxTypeDropDownWorker);
}
export function* taxCombinationImportWatcher() {
  yield takeLatest(TAX_COMBINATION_IMPORT, taxCombinationImportWorker);
}

/**SHipping Type */
export function* shippingTypeAddWatcher() {
  yield takeLatest(ADD_SHIPPING_TYPE, shippingTypeAddWorker);
}

export function* shippingTypeUpdateWatcher() {
  yield takeLatest(UPDATE_SHIPPING_TYPE, shippingTypeUpdateWorker);
}

export function* shippingTypeDeleteWatcher() {
  yield takeLatest(DELETE_SHIPPING_TYPE, shippingTypeDeleteWorker);
}

export function* shippingTypeTableListWatcher() {
  yield takeLatest(SHIPPING_TYPE_TABLE__LIST, shippingTypeListWorker);
}
export function* shippingTypeImportWatcher() {
  yield takeLatest(SHIPPING_TYPE_IMPORT, shippingTypeImportWorker);
}

export function* documentNumberingListWatcher() {
  yield takeLatest(DOCUMENT_NUMBERING_LIST, documentNumberListWorker);
}

export function* documentNumberingUpdateWatcher() {
  yield takeLatest(DOCUMENT_NUMBERING_UPDATE, documentNumberUpdateWorker);
}

export function* documentNumberingSeriesListWatcher() {
  yield takeLatest(
    DOCUMENT_NUMBERING_SERIES_LIST,
    documentNumberSeriesListWorker
  );
}

export function* documentNumberingSeriesAddWatcher() {
  yield takeLatest(
    DOCUMENT_NUMBERING_SERIES_ADD,
    documentNumberSeriesAddWorker
  );
}

export function* documentNumberingSeriesUpdateWatcher() {
  yield takeLatest(
    DOCUMENT_NUMBERING_SERIES_UPDATE,
    documentNumberSeriesUpdateWorker
  );
}
export function* customNumberingListWatcher() {
  yield takeLatest(CUSTOM_NUMBERING_LIST, customNumberListWorker);
}

export function* customNumberingUpdateWatcher() {
  yield takeLatest(CUSTOM_NUMBERING_UPDATE, customNumberUpdateWorker);
}

export function* customNumberingSeriesListWatcher() {
  yield takeLatest(CUSTOM_NUMBERING_SERIES_LIST, customNumberSeriesListWorker);
}

export function* customNumberingSeriesAddWatcher() {
  yield takeLatest(CUSTOM_NUMBERING_SERIES_ADD, customNumberSeriesAddWorker);
}

export function* customNumberingSeriesUpdateWatcher() {
  yield takeLatest(
    CUSTOM_NUMBERING_SERIES_UPDATE,
    customNumberSeriesUpdateWorker
  );
}

/*ROLE AND DEPARTMENT*/
export function* roleCreateWorker(action) {
  try {
    const res = yield call(roleCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* roleSearchWorker(action) {
  try {
    const res = yield call(roleSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* roleEditWorker(action) {
  try {
    const res = yield call(roleEditeApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* roleDeleteWorker(action) {
  try {
    const res = yield call(roleDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* roleDocumentUploadWorker(action) {
  try {
    const res = yield call(roleDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* departmentSearchWorker(action) {
  try {
    const res = yield call(departmentSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* departmentCreateWorker(action) {
  try {
    const res = yield call(departmentCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* departmentEditWorker(action) {
  try {
    const res = yield call(departmentEditeApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* departmentDeleteWorker(action) {
  try {
    const res = yield call(departmentDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* departmentDocumentUploadWorker(action) {
  try {
    const res = yield call(departmentDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* attachedRolesDepartmentCreateWorker(action) {
  try {
    const res = yield call(attachedRolesDepartmentCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* attachedRolesDepartmentDeleteWorker(action) {
  try {
    const res = yield call(attachedRolesDepartmentDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
// DATA SETUP

export function* drugSearchWorker(action) {
  try {
    const res = yield call(drugSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* drugCreateWorker(action) {
  try {
    const res = yield call(drugCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* drugEditWorker(action) {
  try {
    const res = yield call(drugEditeApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* drugDocumentUploadWorker(action) {
  try {
    const res = yield call(drugDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* drugDeleteWorker(action) {
  try {
    const res = yield call(drugDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

//

// Generic workers
export function* genericSearchWorker(action) {
  try {
    const res = yield call(genericSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* genericCreateWorker(action) {
  try {
    const res = yield call(genericCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* genericEditWorker(action) {
  try {
    const res = yield call(genericEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* genericDeleteWorker(action) {
  try {
    const res = yield call(genericDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* genericDocumentUploadWorker(action) {
  try {
    const res = yield call(genericDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

// Composition workers
export function* compositionSearchWorker(action) {
  try {
    const res = yield call(compositionSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* compositionCreateWorker(action) {
  try {
    const res = yield call(compositionCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* compositionEditWorker(action) {
  try {
    const res = yield call(compositionEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* compositionDeleteWorker(action) {
  try {
    const res = yield call(compositionDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* compositionDocumentUploadWorker(action) {
  try {
    const res = yield call(compositionDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

// Lead workers
export function* leadSearchWorker(action) {
  try {
    const res = yield call(leadSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* leadCreateWorker(action) {
  try {
    const res = yield call(leadCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* leadEditWorker(action) {
  try {
    const res = yield call(leadEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* leadDeleteWorker(action) {
  try {
    const res = yield call(leadDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* leadDocumentUploadWorker(action) {
  try {
    const res = yield call(leadDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

// Payment workers
export function* paymentSearchWorker(action) {
  try {
    const res = yield call(paymentSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* paymentCreateWorker(action) {
  try {
    const res = yield call(paymentCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* paymentEditWorker(action) {
  try {
    const res = yield call(paymentEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* paymentDeleteWorker(action) {
  try {
    const res = yield call(paymentDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* paymentDocumentUploadWorker(action) {
  try {
    const res = yield call(paymentDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
//PACKING
// 📦 Packing Workers
export function* packingSearchWorker(action) {
  try {
    const res = yield call(packingSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* packingCreateWorker(action) {
  try {
    const res = yield call(packingCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* packingEditWorker(action) {
  try {
    const res = yield call(packingEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* packingDeleteWorker(action) {
  try {
    const res = yield call(packingDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* packingDocumentUploadWorker(action) {
  try {
    const res = yield call(packingDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

// 📦 Packing Type Workers
export function* packingTypeSearchWorker(action) {
  try {
    const res = yield call(packingTypeSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* packingTypeCreateWorker(action) {
  try {
    const res = yield call(packingTypeCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* packingTypeEditWorker(action) {
  try {
    const res = yield call(packingTypeEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* packingTypeDeleteWorker(action) {
  try {
    const res = yield call(packingTypeDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* packingTypeDocumentUploadWorker(action) {
  try {
    const res = yield call(packingTypeDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

// 📦 Carton Workers
export function* cartonSearchWorker(action) {
  try {
    const res = yield call(cartonSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* cartonCreateWorker(action) {
  try {
    const res = yield call(cartonCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* cartonEditWorker(action) {
  try {
    const res = yield call(cartonEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* cartonDeleteWorker(action) {
  try {
    const res = yield call(cartonDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* cartonDocumentUploadWorker(action) {
  try {
    const res = yield call(cartonDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

//PACKING

// Party workers
export function* partySearchWorker(action) {
  try {
    const res = yield call(partySearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* partyCreateWorker(action) {
  try {
    const res = yield call(partyCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* partyEditWorker(action) {
  try {
    const res = yield call(partyEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* partyDeleteWorker(action) {
  try {
    const res = yield call(partyDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* partyDocumentUploadWorker(action) {
  try {
    const res = yield call(partyDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
//
// ================== PARTY CATEGORY ==================
export function* partyCategorySearchWorker(action) {
  try {
    const res = yield call(partyCategorySearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* partyCategoryCreateWorker(action) {
  try {
    const res = yield call(partyCategoryCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* partyCategoryEditWorker(action) {
  try {
    const res = yield call(partyCategoryEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* partyCategoryDeleteWorker(action) {
  try {
    const res = yield call(partyCategoryDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* partyCategoryDocumentUploadWorker(action) {
  try {
    const res = yield call(partyCategoryDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

// ================== PARTY GROUP ==================
export function* partyGroupSearchWorker(action) {
  try {
    const res = yield call(partyGroupSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* partyGroupCreateWorker(action) {
  try {
    const res = yield call(partyGroupCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* partyGroupEditWorker(action) {
  try {
    const res = yield call(partyGroupEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* partyGroupDeleteWorker(action) {
  try {
    const res = yield call(partyGroupDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* partyGroupDocumentUploadWorker(action) {
  try {
    const res = yield call(partyGroupDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
//LOCATION
// ================= COUNTRY =================
export function* countrySearchWorker(action) {
  try {
    const res = yield call(countrySearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* countryCreateWorker(action) {
  try {
    const res = yield call(countryCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* countryEditWorker(action) {
  try {
    const res = yield call(countryEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* countryDeleteWorker(action) {
  try {
    const res = yield call(countryDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* countryDocumentUploadWorker(action) {
  try {
    const res = yield call(countryDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

// ================= REGION =================
export function* regionSearchWorker(action) {
  try {
    const res = yield call(regionSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* regionCreateWorker(action) {
  try {
    const res = yield call(regionCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* regionEditWorker(action) {
  try {
    const res = yield call(regionEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* regionDeleteWorker(action) {
  try {
    const res = yield call(regionDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* regionDocumentUploadWorker(action) {
  try {
    const res = yield call(regionDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

// ================= STATE =================
export function* stateSearchWorker(action) {
  try {
    const res = yield call(stateSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* stateCreateWorker(action) {
  try {
    const res = yield call(stateCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* stateEditWorker(action) {
  try {
    const res = yield call(stateEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* stateDeleteWorker(action) {
  try {
    const res = yield call(stateDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* stateDocumentUploadWorker(action) {
  try {
    const res = yield call(stateDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

// ================= DISTRICT =================
export function* districtSearchWorker(action) {
  try {
    const res = yield call(districtSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* districtCreateWorker(action) {
  try {
    const res = yield call(districtCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* districtEditWorker(action) {
  try {
    const res = yield call(districtEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* districtDeleteWorker(action) {
  try {
    const res = yield call(districtDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* districtDocumentUploadWorker(action) {
  try {
    const res = yield call(districtDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

// ================= CITY =================
export function* citySearchWorker(action) {
  try {
    const res = yield call(citySearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* cityCreateWorker(action) {
  try {
    const res = yield call(cityCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* cityEditWorker(action) {
  try {
    const res = yield call(cityEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* cityDeleteWorker(action) {
  try {
    const res = yield call(cityDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* cityDocumentUploadWorker(action) {
  try {
    const res = yield call(cityDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

// ================= AREA =================
export function* areaSearchWorker(action) {
  try {
    const res = yield call(areaSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* areaCreateWorker(action) {
  try {
    const res = yield call(areaCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* areaEditWorker(action) {
  try {
    const res = yield call(areaEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* areaDeleteWorker(action) {
  try {
    const res = yield call(areaDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* areaDocumentUploadWorker(action) {
  try {
    const res = yield call(areaDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

//LOCATION

//
// Specialization workers
export function* specializationSearchWorker(action) {
  try {
    const res = yield call(specializationSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* specializationCreateWorker(action) {
  try {
    const res = yield call(specializationCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* specializationEditWorker(action) {
  try {
    const res = yield call(specializationEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* specializationDeleteWorker(action) {
  try {
    const res = yield call(specializationDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* specializationDocumentUploadWorker(action) {
  try {
    const res = yield call(specializationDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

// Sub Special workers
export function* subSpecialSearchWorker(action) {
  try {
    const res = yield call(subSpecialSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* subSpecialCreateWorker(action) {
  try {
    const res = yield call(subSpecialCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* subSpecialEditWorker(action) {
  try {
    const res = yield call(subSpecialEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* subSpecialDeleteWorker(action) {
  try {
    const res = yield call(subSpecialDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* subSpecialDocumentUploadWorker(action) {
  try {
    const res = yield call(subSpecialDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

// Insurance workers
export function* insuranceSearchWorker(action) {
  try {
    const res = yield call(insuranceSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* insuranceCreateWorker(action) {
  try {
    const res = yield call(insuranceCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* insuranceEditWorker(action) {
  try {
    const res = yield call(insuranceEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* insuranceDeleteWorker(action) {
  try {
    const res = yield call(insuranceDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* insuranceDocumentUploadWorker(action) {
  try {
    const res = yield call(insuranceDocumentUploadApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
//
// DATA SETUP

/*-------------------------------------------------*/

export function* smtpViewWatcher() {
  yield takeLatest(SMTP_VIEW, smtpViewWorker);
}

export function* smtpAddWatcher() {
  yield takeLatest(SMTP_ADD, smtpAddWorker);
}

export function* smtpUpdateWatcher() {
  yield takeLatest(SMTP_UPDATE, smtpUpdateWorker);
}

export function* whatsappViewWatcher() {
  yield takeLatest(WHATSAPP_VIEW, whatsappViewWorker);
}

export function* whatsappAddWatcher() {
  yield takeLatest(WHATSAPP_ADD, whatsappAddWorker);
}

export function* whatsappUpdateWatcher() {
  yield takeLatest(WHATSAPP_UPDATE, whatsappUpdateWorker);
}

export function* smsViewWatcher() {
  yield takeLatest(SMS_VIEW, smsViewWorker);
}

export function* smsAddWatcher() {
  yield takeLatest(SMS_ADD, smsAddWorker);
}

export function* smsUpdateWatcher() {
  yield takeLatest(SMS_UPDATE, smsUpdateWorker);
}

export function* razorpayViewWatcher() {
  yield takeLatest(RAZORPAY_VIEW, razorpayViewWorker);
}

export function* razorpayAddWatcher() {
  yield takeLatest(RAZORPAY_ADD, razorpayAddWorker);
}

export function* razorpayUpdateWatcher() {
  yield takeLatest(RAZORPAY_UPDATE, razorpayUpdateWorker);
}

export function* stripeViewWatcher() {
  yield takeLatest(STRIPE_VIEW, stripeViewWorker);
}

export function* stripeAddWatcher() {
  yield takeLatest(STRIPE_ADD, stripeAddWorker);
}

export function* stripeUpdateWatcher() {
  yield takeLatest(STRIPE_UPDATE, stripeUpdateWorker);
}

export function* phonepeViewWatcher() {
  yield takeLatest(PHONEPE_VIEW, phonepeViewWorker);
}

export function* phonepeAddWatcher() {
  yield takeLatest(PHONEPE_ADD, phonepeAddWorker);
}

export function* phonepeUpdateWatcher() {
  yield takeLatest(PHONEPE_UPDATE, phonepeUpdateWorker);
}

export function* paytmViewWatcher() {
  yield takeLatest(PAYTM_VIEW, paytmViewWorker);
}

export function* paytmAddWatcher() {
  yield takeLatest(PAYTM_ADD, paytmAddWorker);
}

export function* paytmUpdateWatcher() {
  yield takeLatest(PAYTM_UPDATE, paytmUpdateWorker);
}

export function* pineLabsViewWatcher() {
  yield takeLatest(PINE_LABS_VIEW, pineLabsViewWorker);
}

export function* pineLabsAddWatcher() {
  yield takeLatest(PINE_LABS_ADD, pineLabsAddWorker);
}

export function* pineLabsUpdateWatcher() {
  yield takeLatest(PINE_LABS_UPDATE, pineLabsUpdateWorker);
}

export function* printPreferenceListWatcher() {
  yield takeLatest(PRINTPREFERENCE_LIST, printPreferenceListWorker);
}

export function* printPreferenceUpdateWatcher() {
  yield takeLatest(PRINTPREFERENCE_UPDATE, printPreferenceUpdateWorker);
}

export function* BillTypesWatcher() {
  yield takeLatest(BILLING_TYPES, BillTypesWorker);
}

export function* currentPrintPreferenceeWatcher() {
  yield takeLatest(CURRENT_PRINTPREFERENCE, currentPrintPreferenceWorker);
}
export function* storeDetailsUpdateWatcher() {
  yield takeLatest(STORE_UPDATE, storeDetailsUpdateWorker);
}

export function* storeDetailsGetWatcher() {
  yield takeLatest(STORE_GET, storeDetailsGetWorker);
}

export function* mapAlternativerItemWatcher() {
  yield takeLatest(MAP_ALTERNATIVE_ITEM, mapAlternativerItemWorker);
}
export function* alternativeItemsListWatcher() {
  yield takeLatest(ALTERNATIVE_ITEMS_LIST, alternativeItemsListWorker);
}
export function* deleteAlternativeTransWatcher() {
  yield takeLatest(
    DELETE_ALTERNATIVE_TRANSACTION,
    deleteAlternativeTransWorker
  );
}
export function* alternativerItemImportWatcher() {
  yield takeLatest(ALTERNATIVE_ITEMS_IMPORT, alternativerItemImportWorker);
}

export function* addCustomInvoiceWatcher() {
  yield takeLatest(ADD_CUSTOM_INVOICE, addCustomInvoiceWorker);
}

/**TCS TDS setup */
export function* tcsTaxCreateWatcher() {
  yield takeLatest(TCS_TAX_ADD, tcsTaxCreateWorker);
}

export function* tcsTaxDeleteWatcher() {
  yield takeLatest(TCS_TAX_DELETE, tcsTaxDeleteWorker);
}

export function* tcsTaxListWatcher() {
  yield takeLatest(TCS_TAX_LIST, tcsTaxListWorker);
}
export function* tcsTaxImportWatcher() {
  yield takeLatest(TCS_TAX_IMPORT, tcsTaxImportWorker);
}
export function* tdsTaxCreateWatcher() {
  yield takeLatest(TDS_TAX_ADD, tdsTaxCreateWorker);
}

export function* tdsTaxDeleteWatcher() {
  yield takeLatest(TDS_TAX_DELETE, tdsTaxDeleteWorker);
}

export function* tdsTaxListWatcher() {
  yield takeLatest(TDS_TAX_LIST, tdsTaxListWorker);
}
export function* tdsTaxImportWatcher() {
  yield takeLatest(TDS_TAX_IMPORT, tdsTaxImportWorker);
}
export function* partyListWatcher() {
  yield takeLatest(PARTY_LIST, partyListWorker);
}

export function* templateCreateWatcher() {
  yield takeLatest(TEMPLATE_CREATE, templateCreateWorker);
}
export function* templateTableWatcher() {
  yield takeLatest(TEMPLATE_TABLE, templateTableWorker);
}
export function* templateViewWatcher() {
  yield takeLatest(TEMPLATE_VIEW, templateViewWorker);
}
export function* templateEditWatcher() {
  yield takeLatest(TEMPLATE_EDIT, templateEditWorker);
}
export function* templateDeleteWatcher() {
  yield takeLatest(TEMPLATE_DELETE, templateDeleteWorker);
}

/* ROLE AND DEPARTMENT */

export function* roleCreateWatcher() {
  yield takeLatest(ROLE_CREATE, roleCreateWorker);
}
export function* roleSearchWatcher() {
  yield takeLatest(ROLE_SEARCH, roleSearchWorker);
}
export function* roleEditWatcher() {
  yield takeLatest(ROLE_EDIT, roleEditWorker);
}
export function* roleDeleteWatcher() {
  yield takeLatest(ROLE_DELETE, roleDeleteWorker);
}
export function* roleDocumentUploadWatcher() {
  yield takeLatest(ROLE_UPLOAD, roleDocumentUploadWorker);
}
export function* departmentCreateWatcher() {
  yield takeLatest(DEPARTMENT_CREATE, departmentCreateWorker);
}
export function* departmentSearchWatcher() {
  yield takeLatest(DEPARTMENT_SEARCH, departmentSearchWorker);
}
export function* departmentEditWatcher() {
  yield takeLatest(DEPARTMENT_EDIT, departmentEditWorker);
}
export function* departmentDeleteWatcher() {
  yield takeLatest(DEPARTMENT_DELETE, departmentDeleteWorker);
}
export function* departmentDocumentUploadWatcher() {
  yield takeLatest(DEPARTMENT_UPLOAD, departmentDocumentUploadWorker);
}

export function* attachedRolesDepartmentCreateWatcher() {
  yield takeLatest(
    ATTACHED_ROLES_DEPARTMENT_CREATE,
    attachedRolesDepartmentCreateWorker
  );
}
export function* attachedRolesDepartmentDeleteWatcher() {
  yield takeLatest(
    ATTACHED_ROLES_DEPARTMENT_DELETE,
    attachedRolesDepartmentDeleteWorker
  );
}

export function* drugSearchWatcher() {
  yield takeLatest(DRUG_SEARCH, drugSearchWorker);
}

export function* drugCreateWatcher() {
  yield takeLatest(DRUG_CREATE, drugCreateWorker);
}
export function* drugEditWatcher() {
  yield takeLatest(DRUG_EDIT, drugEditWorker);
}
export function* drugDeleteWatcher() {
  yield takeLatest(DRUG_DELETE, drugDeleteWorker);
}
export function* drugDocumentUploadWatcher() {
  yield takeLatest(DRUG_UPLOAD, drugDocumentUploadWorker);
}

//

// // Generic watchers
export function* genericSearchWatcher() {
  yield takeLatest(GENERIC_SEARCH, genericSearchWorker);
}

export function* genericCreateWatcher() {
  yield takeLatest(GENERIC_CREATE, genericCreateWorker);
}

export function* genericEditWatcher() {
  yield takeLatest(GENERIC_EDIT, genericEditWorker);
}

export function* genericDeleteWatcher() {
  yield takeLatest(GENERIC_DELETE, genericDeleteWorker);
}

export function* genericDocumentUploadWatcher() {
  yield takeLatest(GENERIC_UPLOAD, genericDocumentUploadWorker);
}

// Composition watchers
export function* compositionSearchWatcher() {
  yield takeLatest(COMPOSITION_SEARCH, compositionSearchWorker);
}

export function* compositionCreateWatcher() {
  yield takeLatest(COMPOSITION_CREATE, compositionCreateWorker);
}

export function* compositionEditWatcher() {
  yield takeLatest(COMPOSITION_EDIT, compositionEditWorker);
}

export function* compositionDeleteWatcher() {
  yield takeLatest(COMPOSITION_DELETE, compositionDeleteWorker);
}

export function* compositionDocumentUploadWatcher() {
  yield takeLatest(COMPOSITION_UPLOAD, compositionDocumentUploadWorker);
}

// Lead watchers
export function* leadSearchWatcher() {
  yield takeLatest(LEAD_SEARCH, leadSearchWorker);
}

export function* leadCreateWatcher() {
  yield takeLatest(LEAD_CREATE, leadCreateWorker);
}

export function* leadEditWatcher() {
  yield takeLatest(LEAD_EDIT, leadEditWorker);
}

export function* leadDeleteWatcher() {
  yield takeLatest(LEAD_DELETE, leadDeleteWorker);
}

export function* leadDocumentUploadWatcher() {
  yield takeLatest(LEAD_UPLOAD, leadDocumentUploadWorker);
}

// Payment watchers
export function* paymentSearchWatcher() {
  yield takeLatest(PAYMENT_SEARCH, paymentSearchWorker);
}

export function* paymentCreateWatcher() {
  yield takeLatest(PAYMENT_CREATE, paymentCreateWorker);
}

export function* paymentEditWatcher() {
  yield takeLatest(PAYMENT_EDIT, paymentEditWorker);
}

export function* paymentDeleteWatcher() {
  yield takeLatest(PAYMENT_DELETE, paymentDeleteWorker);
}

export function* paymentDocumentUploadWatcher() {
  yield takeLatest(PAYMENT_UPLOAD, paymentDocumentUploadWorker);
}
//packing
// 📦 Packing Watchers
export function* packingSearchWatcher() {
  yield takeLatest(PACKING_SEARCH, packingSearchWorker);
}

export function* packingCreateWatcher() {
  yield takeLatest(PACKING_CREATE, packingCreateWorker);
}

export function* packingEditWatcher() {
  yield takeLatest(PACKING_EDIT, packingEditWorker);
}

export function* packingDeleteWatcher() {
  yield takeLatest(PACKING_DELETE, packingDeleteWorker);
}

export function* packingDocumentUploadWatcher() {
  yield takeLatest(PACKING_UPLOAD, packingDocumentUploadWorker);
}

// 📦 Packing Type Watchers
export function* packingTypeSearchWatcher() {
  yield takeLatest(PACKING_TYPE_SEARCH, packingTypeSearchWorker);
}

export function* packingTypeCreateWatcher() {
  yield takeLatest(PACKING_TYPE_CREATE, packingTypeCreateWorker);
}

export function* packingTypeEditWatcher() {
  yield takeLatest(PACKING_TYPE_EDIT, packingTypeEditWorker);
}

export function* packingTypeDeleteWatcher() {
  yield takeLatest(PACKING_TYPE_DELETE, packingTypeDeleteWorker);
}

export function* packingTypeDocumentUploadWatcher() {
  yield takeLatest(PACKING_TYPE_UPLOAD, packingTypeDocumentUploadWorker);
}

// 📦 Carton Watchers
export function* cartonSearchWatcher() {
  yield takeLatest(CARTON_SEARCH, cartonSearchWorker);
}

export function* cartonCreateWatcher() {
  yield takeLatest(CARTON_CREATE, cartonCreateWorker);
}

export function* cartonEditWatcher() {
  yield takeLatest(CARTON_EDIT, cartonEditWorker);
}

export function* cartonDeleteWatcher() {
  yield takeLatest(CARTON_DELETE, cartonDeleteWorker);
}

export function* cartonDocumentUploadWatcher() {
  yield takeLatest(CARTON_UPLOAD, cartonDocumentUploadWorker);
}

//packing

// Party watchers
export function* partySearchWatcher() {
  yield takeLatest(PARTY_SEARCH, partySearchWorker);
}

export function* partyCreateWatcher() {
  yield takeLatest(PARTY_CREATE, partyCreateWorker);
}

export function* partyEditWatcher() {
  yield takeLatest(PARTY_EDIT, partyEditWorker);
}

export function* partyDeleteWatcher() {
  yield takeLatest(PARTY_DELETE, partyDeleteWorker);
}

export function* partyDocumentUploadWatcher() {
  yield takeLatest(PARTY_UPLOAD, partyDocumentUploadWorker);
}

//

// ================== PARTY CATEGORY ==================
export function* partyCategorySearchWatcher() {
  yield takeLatest(PARTY_CATEGORY_SEARCH, partyCategorySearchWorker);
}

export function* partyCategoryCreateWatcher() {
  yield takeLatest(PARTY_CATEGORY_CREATE, partyCategoryCreateWorker);
}

export function* partyCategoryEditWatcher() {
  yield takeLatest(PARTY_CATEGORY_EDIT, partyCategoryEditWorker);
}

export function* partyCategoryDeleteWatcher() {
  yield takeLatest(PARTY_CATEGORY_DELETE, partyCategoryDeleteWorker);
}

export function* partyCategoryDocumentUploadWatcher() {
  yield takeLatest(PARTY_CATEGORY_UPLOAD, partyCategoryDocumentUploadWorker);
}

// ================== PARTY GROUP ==================
export function* partyGroupSearchWatcher() {
  yield takeLatest(PARTY_GROUP_SEARCH, partyGroupSearchWorker);
}

export function* partyGroupCreateWatcher() {
  yield takeLatest(PARTY_GROUP_CREATE, partyGroupCreateWorker);
}

export function* partyGroupEditWatcher() {
  yield takeLatest(PARTY_GROUP_EDIT, partyGroupEditWorker);
}

export function* partyGroupDeleteWatcher() {
  yield takeLatest(PARTY_GROUP_DELETE, partyGroupDeleteWorker);
}

export function* partyGroupDocumentUploadWatcher() {
  yield takeLatest(PARTY_GROUP_UPLOAD, partyGroupDocumentUploadWorker);
}

//

// LOCATION
// COUNTRY
export function* countrySearchWatcher() {
  yield takeLatest(COUNTRY_SEARCH, countrySearchWorker);
}

export function* countryCreateWatcher() {
  yield takeLatest(COUNTRY_CREATE, countryCreateWorker);
}

export function* countryEditWatcher() {
  yield takeLatest(COUNTRY_EDIT, countryEditWorker);
}

export function* countryDeleteWatcher() {
  yield takeLatest(COUNTRY_DELETE, countryDeleteWorker);
}

export function* countryDocumentUploadWatcher() {
  yield takeLatest(COUNTRY_UPLOAD, countryDocumentUploadWorker);
}

// REGION
export function* regionSearchWatcher() {
  yield takeLatest(REGION_SEARCH, regionSearchWorker);
}

export function* regionCreateWatcher() {
  yield takeLatest(REGION_CREATE, regionCreateWorker);
}

export function* regionEditWatcher() {
  yield takeLatest(REGION_EDIT, regionEditWorker);
}

export function* regionDeleteWatcher() {
  yield takeLatest(REGION_DELETE, regionDeleteWorker);
}

export function* regionDocumentUploadWatcher() {
  yield takeLatest(REGION_UPLOAD, regionDocumentUploadWorker);
}

// STATE
export function* stateSearchWatcher() {
  yield takeLatest(STATE_SEARCH, stateSearchWorker);
}

export function* stateCreateWatcher() {
  yield takeLatest(STATE_CREATE, stateCreateWorker);
}

export function* stateEditWatcher() {
  yield takeLatest(STATE_EDIT, stateEditWorker);
}

export function* stateDeleteWatcher() {
  yield takeLatest(STATE_DELETE, stateDeleteWorker);
}

export function* stateDocumentUploadWatcher() {
  yield takeLatest(STATE_UPLOAD, stateDocumentUploadWorker);
}

// DISTRICT
export function* districtSearchWatcher() {
  yield takeLatest(DISTRICT_SEARCH, districtSearchWorker);
}

export function* districtCreateWatcher() {
  yield takeLatest(DISTRICT_CREATE, districtCreateWorker);
}

export function* districtEditWatcher() {
  yield takeLatest(DISTRICT_EDIT, districtEditWorker);
}

export function* districtDeleteWatcher() {
  yield takeLatest(DISTRICT_DELETE, districtDeleteWorker);
}

export function* districtDocumentUploadWatcher() {
  yield takeLatest(DISTRICT_UPLOAD, districtDocumentUploadWorker);
}

// CITY
export function* citySearchWatcher() {
  yield takeLatest(CITY_SEARCH, citySearchWorker);
}

export function* cityCreateWatcher() {
  yield takeLatest(CITY_CREATE, cityCreateWorker);
}

export function* cityEditWatcher() {
  yield takeLatest(CITY_EDIT, cityEditWorker);
}

export function* cityDeleteWatcher() {
  yield takeLatest(CITY_DELETE, cityDeleteWorker);
}

export function* cityDocumentUploadWatcher() {
  yield takeLatest(CITY_UPLOAD, cityDocumentUploadWorker);
}

// AREA
export function* areaSearchWatcher() {
  yield takeLatest(AREA_SEARCH, areaSearchWorker);
}

export function* areaCreateWatcher() {
  yield takeLatest(AREA_CREATE, areaCreateWorker);
}

export function* areaEditWatcher() {
  yield takeLatest(AREA_EDIT, areaEditWorker);
}

export function* areaDeleteWatcher() {
  yield takeLatest(AREA_DELETE, areaDeleteWorker);
}

export function* areaDocumentUploadWatcher() {
  yield takeLatest(AREA_UPLOAD, areaDocumentUploadWorker);
}

// LOCATION

// Specialization watchers
export function* specializationSearchWatcher() {
  yield takeLatest(SPECIALIZATION_SEARCH, specializationSearchWorker);
}

export function* specializationCreateWatcher() {
  yield takeLatest(SPECIALIZATION_CREATE, specializationCreateWorker);
}

export function* specializationEditWatcher() {
  yield takeLatest(SPECIALIZATION_EDIT, specializationEditWorker);
}

export function* specializationDeleteWatcher() {
  yield takeLatest(SPECIALIZATION_DELETE, specializationDeleteWorker);
}

export function* specializationDocumentUploadWatcher() {
  yield takeLatest(SPECIALIZATION_UPLOAD, specializationDocumentUploadWorker);
}

// Sub Special watchers
export function* subSpecialSearchWatcher() {
  yield takeLatest(SUB_SPECIAL_SEARCH, subSpecialSearchWorker);
}

export function* subSpecialCreateWatcher() {
  yield takeLatest(SUB_SPECIAL_CREATE, subSpecialCreateWorker);
}

export function* subSpecialEditWatcher() {
  yield takeLatest(SUB_SPECIAL_EDIT, subSpecialEditWorker);
}

export function* subSpecialDeleteWatcher() {
  yield takeLatest(SUB_SPECIAL_DELETE, subSpecialDeleteWorker);
}

export function* subSpecialDocumentUploadWatcher() {
  yield takeLatest(SUB_SPECIAL_UPLOAD, subSpecialDocumentUploadWorker);
}

// Insurance watchers
export function* insuranceSearchWatcher() {
  yield takeLatest(INSURANCE_SEARCH, insuranceSearchWorker);
}

export function* insuranceCreateWatcher() {
  yield takeLatest(INSURANCE_CREATE, insuranceCreateWorker);
}

export function* insuranceEditWatcher() {
  yield takeLatest(INSURANCE_EDIT, insuranceEditWorker);
}

export function* insuranceDeleteWatcher() {
  yield takeLatest(INSURANCE_DELETE, insuranceDeleteWorker);
}

export function* insuranceDocumentUploadWatcher() {
  yield takeLatest(INSURANCE_UPLOAD, insuranceDocumentUploadWorker);
}
//

// DATA SETUP

export function* moduleSettingsGetAllWorker(action) {
  try {
    const res = yield call(moduleSettingsGetAllApi);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* moduleSettingsUpdateWorker(action) {
  try {
    const res = yield call(moduleSettingsUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* moduleSettingsGetAllWatcher() {
  yield takeLatest(MODULE_SETTINGS_GET_ALL, moduleSettingsGetAllWorker);
}
export function* moduleSettingsUpdateWatcher() {
  yield takeLatest(MODULE_SETTINGS_UPDATE, moduleSettingsUpdateWorker);
}
